<template>
  <v-content>
    <v-container
      fill-height
      fluid>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <card>
            <h5>Admin Panel</h5>
            <v-spacer/>
            <v-form >
              <base-input
                ref="username"
                v-model="username"
                required
                prepend-icon="mdi-account"
                label="Login"
                placeholder="Username"
              />
              <base-input
                ref="password"
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Password"
                placeholder="*********"
                counter
                required
                @keydown.enter="login"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
            <v-divider class="mt-5"/>
            <v-spacer/>
            <base-button
              slot="footer"
              class="float-right"
              type="primary"
              @click="login">Login
            </base-button>
            <v-snackbar
              v-model="snackbar"
              :color="color"
              :top="true"
            >
              {{ errorMessages }}
              <v-btn
                dark
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </card>
        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      username: '',
      password: '',
      errorMessages: 'Incorrect login info',
      snackbar: false,
      color: 'general',
      showPassword: false
    }
  },

  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      this.$store.state.spinning = true
      this.$store.dispatch('login', { username, password })
        .then(() => {
          this.$router.push('/users')
          this.$store.state.spinning = false
        })
        .catch(err => {
          console.log(err)
          this.snackbar = true
          this.$store.state.spinning = false
          this.errorMessages = 'Wrong username or password'
        }
        )
    }
  },
  metaInfo () {
    return {
      title: 'Super Secret | Login'
    }
  }
}
</script>
